export const TableNote = () => {
    return (
        <p className='text-danger  text-end' style={{marginBottom:"0.5em", fontSize:"0.9em"}}>
            Note : Only todays date data will be Edit or Delete.
        </p>
    )
}